import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useUserPermissionOrFeatureFlagEnabled } from 'modules/taboola-common-frontend-modules/account-configurations/hooks/useUserPermissionOrFeatureFlagEnabled';

export const useCreateLookalikePermitted = () => {
    const createLookalikeAllowed = useUserPermissionOrFeatureFlagEnabled(
        'CREATE_LOOKALIKE_ALLOWED',
        FEATURE_FLAGS.CREATE_LOOKALIKE_ALLOWED
    );
    const createLookalikeAllowedNew = useUserPermissionOrFeatureFlagEnabled(
        'CREATE_LOOKALIKE_ALLOWED_NEW',
        FEATURE_FLAGS.CREATE_LOOKALIKE_ALLOWED_NEW
    );

    return createLookalikeAllowed && createLookalikeAllowedNew;
};
